import React from 'react'
import {Box, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import { pxToRem } from '../../utills/pxToRem'

function StoreAddress({storeDetails, ...containerProps}) {
    const {name = '', address1 = '', city = '', postalCode = '', stateCode = ''} = storeDetails || {}
    return (
        <Box as="p" {...containerProps} lineHeight='normal'>
            <Text as="span" fontWeight={400} color="black" fontSize={["14px", "16px"]} lineHeight='normal' letterSpacing={pxToRem(1)}>
                <FormattedMessage
                    defaultMessage="My Store: "
                    id="store_address.my_store.label"
                    description="store address label"
                />
            </Text>
                {" "}
            <Text as="span" fontWeight={500} color="black" fontSize={["14px", "16px"]} lineHeight='normal' letterSpacing={pxToRem(1)} >
                {name && address1 ? `${name} ${address1} ${city}${city && ','} ${stateCode} ${postalCode}` : <FormattedMessage
                    defaultMessage="Find Your Cavender’s"
                    id="store_address.my_store.default_msg"
                    description="Default address placeholder"
                />}
            </Text>
        </Box>
    )
}

StoreAddress.propTypes = {
    storeDetails: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        address1: PropTypes.string,
        city: PropTypes.string,
        countryCode: PropTypes.string,
        postalCode: PropTypes.string,
        stateCode: PropTypes.string
    })
}

export default StoreAddress
